import React, { useEffect, useState, useCallback } from 'react';
import { useLocalSessionId, useVideoTrack, useAudioTrack, useAudioLevel } from '@daily-co/daily-react';
import Mic from '../Mic/Mic';

const DailyMic: React.FC<{ userId: string, height?: number }> = ({ userId, height = 18 }) => {
  const localAudio = useAudioTrack(userId);
  const [isEnabled, setIsEnabled] = useState(localAudio.state === 'playable' && localAudio.persistentTrack?.readyState === 'live');
  const [volume, setVolume] = useState(0);
  
  const handleVolumeChange = useCallback((value: number) => {
    // console.log('volume for local audio track:', value);
    setVolume(value);
  }, []);

  useAudioLevel(localAudio.persistentTrack, handleVolumeChange);

  useEffect(() => {
    setIsEnabled(localAudio.state === 'playable' && localAudio.persistentTrack?.readyState === 'live');
  }, [localAudio.state, localAudio.persistentTrack?.readyState]);

  return (
    <Mic isEnabled={isEnabled} volume={volume} height={height} />
  );
};

export default DailyMic;
